<template>

    <ui-view class="view-action-form" v-spinner="loading" :hide="loading">

        <ui-heading :title="pageTitle">
            <ui-button color="positive" :loading="submitting" @click="$refs.form.submit()">Opslaan</ui-button>
            <ui-button
                color="medium"
                type="bordered"
                :to="backRoute"
                slot="left">Annuleren</ui-button>
        </ui-heading>

        <ui-form-panel auto-validate ref="form" @submit="submit">

            <ui-form-date-input
                title="Datum"
                name="date"
                rules="required"
                v-model="pendingHarvest.date"/>

            <ui-form-input
                number
                title="Bruto"
                name="brutoWeight"
                suffix="mTon"
                v-model="pendingHarvest.brutoWeight"/>

            <ui-form-input
                number
                title="Netto"
                name="nettoWeight"
                suffix="mTon"
                v-model="pendingHarvest.nettoWeight"/>

            <ui-form-input
                decimal
                title="Tarra"
                name="tarra"
                suffix="%"
                v-model="pendingHarvest.tarra"/>

            <ui-form-input
                number
                title="Bustal"
                name="bustal"
                v-model="pendingHarvest.bustal"/>

            <ui-form-input
                number
                title="Stukstal"
                name="stukstal"
                v-model="pendingHarvest.stukstal"/>

            <ui-form-switch
                title="Leeggevist"
                name="emptied"
                v-model="pendingHarvest.emptied"/>

            <ui-form-textarea
                title="Bijzonderheden"
                name="notes"
                v-model="pendingHarvest.notes"/>

        </ui-form-panel>

    </ui-view>

</template>

<script>

import Vue from 'vue';
import moment from 'moment';
import { clone, pick } from 'es-toolkit';
import Component from 'vue-class-component';

import createQuery from 'js-core/js/apollo/queries/createQuery';

import actionTypeTitleFilter from 'common/filters/actionTypeTitle';

import FindHarvestQuery from 'gql/queries/HarvestForm/FindHarvest.gql';

import HarvestMutations from 'app/mutations/HarvestMutations';

@Component({

    name: 'HarvestForm',
    apollo: {
        harvest: createQuery(FindHarvestQuery, {

            skip() {
                return !this.harvestId;
            },

            variables() {

                return {
                    id: this.harvestId
                };
            },

            response(response) {

                this.pendingHarvest = pick(response, Object.keys(this.pendingHarvest));
                this.pendingHarvest.date = moment(this.pendingHarvest.date).format('YYYY-MM-DD');
            }
        })
    }
})
export default class HarvestForm extends Vue
{
    loading = 0;
    submitting = false;

    pendingHarvest = {
        date: null,
        brutoWeight: null,
        nettoWeight: null,
        tarra: null,
        bustal: null,
        stukstal: null,
        emptied: false,
        notes: null
    };

    breadcrumb(){

        return [{
            title: 'Vak detail',
            route: this.backRoute
        }, this.pageTitle];
    }

    async submit() {

        this.submitting = true;
        let input = clone(this.pendingHarvest);

        try {

            input.id = this.harvestId;

            await HarvestMutations.update(input);

            this.logger.info('Harvest updated');
            this.$toast.success(`De ${this.actionType} is aangepast`);

            this.$router.replace(this.backRoute);
        }
        catch(e) {

            this.logger.error('Error updating harvest', e);
            this.$toast.error(`De ${this.actionType} kon niet worden opgeslagen`);
        }

        this.submitting = false;
    }

    get pageTitle(){

        return this.actionType ? `${this.actionType} wijzigen` : null;
    }

    get actionType(){

        return this.harvest ? actionTypeTitleFilter(this.harvest.__typename, this.harvest) : null;
    }

    get harvestId(){

        return this.$route.params.id;
    }

    get backRoute(){

        if(!this.harvest){
            return { name: 'sections'};
        }

        return {
            name: 'section-detail',
            params: {
                id: this.harvest.cohort.sectionId
            }
        };
    }
}

</script>